<template>
  <div
    :class="componentClasses"
  >
    <div class="stk-key-info-label">
      <Icon
        v-if="icon"
        :icon="icon"
      />
      <div class="stk-key-info-label-text">
        <slot name="label" />
      </div>
    </div>
    <div class="stk-key-info-main">
      <slot name="main" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@stakeui/graphic/icon/Icon.vue';

const props = defineProps({
  icon: {
    type: String,
  },
  size: {
    type: String,
  },
});

const componentClasses = computed(() => [
  'stk-key-info',
  props.size ? `stk-size-${props.size}` : '', // Add size class if 'size' is defined
]);
</script>

<style>
.stk-key-info {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.stk-key-info-label {
  color: var(--stk-text-weak);
  display: flex;
  align-items: center;
  gap: 0.5em;
  min-height: 1.25rem;
}

.stk-key-info-label-icon {
  opacity: 0.5;
}

.stk-key-info-label-text {
  font-weight: 500;
  font-size: 0.875em;
  line-height: 1rem;
}
</style>
